import { useContext, useEffect, useState } from 'react'

import BackIcon from '../icons/BackIcon'
import CrosshairsIcon from '../icons/CrosshairsIcon'
import DoubleBackIcon from '../icons/DoubleBackIcon'
import DownIcon from '../icons/DownIcon'
import IconContainer from '../icons/IconContainer'
import LayerGroupIcon from '../icons/LayerGroupIcon'
import LocationArrowIcon from '../icons/LocationArrowIcon'

import { Header } from '../basic-components/HeaderFooter'
import HeaderTitle from '../basic-components/HeaderTitle'

import MapContext from '../context/MapContext'
import QueryContext from '../context/QueryContext'

import Select from '../basic-components/Select'

import FullResults from './FullResults'
import PartialResults from './PartialResults'
import SlidePanel from './SlidePanel'


const mapUnitsOptions = [
  {
    label: "NC State Plane",
    value: "nc-state-plane",
  },{
    label: "Latitude, Longitude",
    value: "lat-long",
  }
];

const queryTypeOptions = [
  {
    label: "Single Parcel Tax Info",
    value: "single-parcel",
  },{
    label: "Multiple Layers",
    value: "multiple-layers",
  },{
    label: "Zoning",
    value: "zoning",
  },{
    label: "School Districts",
    value: "school-districts",
  }
];

export default function MapOverlay({
  onBackClick,
  onDoubleBackClick,
  onCrosshairsClick,
  onLayersClick,
  goToNote,
}) {
  const { moveTo, currentLocation, queryLocation, showResultOnMap, zoomCloser } = useContext(MapContext);
  const { queryType, queryData, setQueryType } = useContext(QueryContext);

  // slideStatus = ['hide', 'full', 'partial', 'settings']
  const [ slideStatus, setSlideStatus ] = useState('hide');
  const [ displayCoordinates, setDisplayCoordinates ] = useState(null);
  const [ mapUnits, setMapUnits ] = useState("nc-state-plane");

  const locationArrowClickHandler = () => {
    //console.log(currentLocation);
    if (currentLocation) {
      const point = [currentLocation.x, currentLocation.y];
      moveTo(point);
      zoomCloser();
    }
  }

  const setSlideStatusFull = () => {
    setSlideStatus('full');
  }

  const setSlideStatusPartial = () => {
    setSlideStatus('partial');
  }

  // set location to queryClick or text search markerLocation
  // if no location, no results to show???
  useEffect(() => {
    let coordinates = null;
    if (queryLocation) {
      coordinates = [queryLocation[0], queryLocation[1]];
    } else if (queryData) {
      coordinates = [
        parseFloat(queryData.markerLocation[0]),
        parseFloat(queryData.markerLocation[1])
      ];
    }
    //console.log(coordinates);
    if (coordinates) {
      if (slideStatus === 'hide') {
          setSlideStatus('partial');
      }
    }
    setDisplayCoordinates(coordinates);
  },[queryLocation, queryData, slideStatus]);

  //console.warn('*** rendering MapOverlay ***');
  //console.log(slideStatus);
  //console.log(queryLocation);
  //console.log(queryData);
  //console.log(displayCoordinates);

  // could be:
  // 1. parcel
  // 2. street segment (has_rightlow)
  // 3. nothing found (clicked in street)

  let resultsDisplay;
  //console.log(slideStatus);
  switch (slideStatus) {
    case 'full':
      resultsDisplay = (
        <>
          <Header>
            <IconContainer>
              <DownIcon onClick={setSlideStatusPartial}/>
            </IconContainer>
            <HeaderTitle><strong>Query Result</strong></HeaderTitle>
            <IconContainer justify="right" >
              <CrosshairsIcon onClick={() => {
                showResultOnMap(queryData);
                setSlideStatusPartial();
              }}/>
            </IconContainer>
          </Header>
          <FullResults
            coordinates={displayCoordinates}
            mapUnits={mapUnits}
            queryData={queryData}
            onLessClick={setSlideStatusPartial}
          />
        </>
      );
      break;
    case 'partial':
      resultsDisplay = (
        <PartialResults
          coordinates={displayCoordinates}
          mapUnits={mapUnits}
          queryType={queryType}
          queryData={queryData}
          onMoreClick={setSlideStatusFull}
          onSettingsClick={() => setSlideStatus('settings')}
          goToNote={goToNote}
        />
      );
      break;
    case 'settings':
      resultsDisplay = (
        <>
          <div style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            backgroundColor: '#EFE5C1',
            marginBottom: '0.5rem',
            padding: '0.5rem',
          }}>
            <button onClick={setSlideStatusPartial} >
              DONE
            </button>
          </div>
          <div>
            <Select
              label="Map Units: "
              options={mapUnitsOptions}
              selectedValue={mapUnits}
              onChange={setMapUnits}
            />
           <br/><br/>
           <Select
             label="QueryType: "
             options={queryTypeOptions}
             selectedValue={queryType}
             onChange={setQueryType}
           />
          </div>
        </>
      );
      break;
    default:
      resultsDisplay = null;
  }

  return (
    <>
      <Header>
        <IconContainer>
          {onDoubleBackClick ? (<DoubleBackIcon onClick={onDoubleBackClick}/>) : null}
          <BackIcon onClick={onBackClick}/>
        </IconContainer>
        <HeaderTitle><strong>Map</strong></HeaderTitle>
        <IconContainer justify="right" >
          <LocationArrowIcon onClick={locationArrowClickHandler}/>
          <CrosshairsIcon onClick={onCrosshairsClick}/>
          <LayerGroupIcon onClick={onLayersClick}/>
        </IconContainer>
      </Header>
      {(slideStatus === 'hide') ? null : (
        <SlidePanel status={slideStatus} >
          {resultsDisplay}
        </SlidePanel>
      )}
    </>
  );
}
